import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { formatCurrency, getAlert, getData, getDataWithJoin, parseCurrency } from "./SamuiUtils";
import { formatDate, formatDateAndTime, formatUTCDateAndTime } from "./DateUtils";

export async function ExportInventories(data) {
    if (!Array.isArray(data) || data.length === 0) {
        return getAlert("FAILED", "ไม่มีข้อมูลสินค้าคงเหลือ");
    }

    try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("สินค้าคงเหลือ");

        // เพิ่ม Header พร้อมกำหนดสไตล์
        worksheet.columns = [
            { header: "รหัสสินค้า", key: "Item_Code", width: 15 },
            { header: "ชื่อสินค้า", key: "Item_Name", width: 30 },
            { header: "คงเหลือ", key: "Item_Onhand", width: 15 },
            { header: "คลังสินค้า", key: "WH_Name", width: 20 },
            { header: "รายการล่าสุด", key: "Last_STC_Date", width: 25 },
        ];

        worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFF0000" } }; // ตัวหนังสือสีแดง
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFFFFF00" }, // สีเหลือง
            };
            cell.alignment = { vertical: "middle", horizontal: "center" }; // จัดตำแหน่งกลาง
        });

        // เพิ่มข้อมูล
        data.forEach((item) => {
            worksheet.addRow({
                Item_Code: item.Item_Code,
                Item_Name: item.Item_Name,
                Item_Onhand: formatCurrency(item.Item_Onhand),
                WH_Name: item.WH_Name,
                Last_STC_Date: formatDateAndTime(item.Last_STC_Date),
            });
        });

        // บันทึกไฟล์
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), "สินค้าคงเหลือ.xlsx");
    } catch (error) {
        console.error("Error exporting inventories:", error);
        getAlert("FAILED", "ไม่สามารถ Export ข้อมูลได้");
    }
}

export async function ExportInventoriesWarehouse(data) {
    if (!Array.isArray(data) || data.length === 0) {
        return getAlert("FAILED", "ไม่มีข้อมูลสินค้าแยกตามคลัง");
    }

    try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("สินค้าแยกตามคลัง");

        // เพิ่ม Header พร้อมกำหนดสไตล์
        worksheet.columns = [
            { header: "รหัสสินค้า", key: "Item_Code", width: 15 },
            { header: "ชื่อสินค้า", key: "Item_Name", width: 30 },
            { header: "คงเหลือ", key: "Item_Onhand", width: 15 },
            { header: "คลังสินค้า", key: "WH_Name", width: 20 },
            { header: "รายการล่าสุด", key: "Last_STC_Date", width: 25 },
        ];

        worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFF0000" } }; // ตัวหนังสือสีแดง
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFFFFF00" }, // สีเหลือง
            };
            cell.alignment = { vertical: "middle", horizontal: "center" }; // จัดตำแหน่งกลาง
        });

        // เพิ่มข้อมูล
        data.forEach((item) => {
            worksheet.addRow({
                Item_Code: item.Item_Code,
                Item_Name: item.Item_Name,
                Item_Onhand: formatCurrency(item.Item_Onhand),
                WH_Name: item.WH_Name,
                Last_STC_Date: formatDateAndTime(item.Last_STC_Date),
            });
        });

        // บันทึกไฟล์
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), "สินค้าแยกตามคลัง.xlsx");
    } catch (error) {
        console.error("Error exporting inventories:", error);
        getAlert("FAILED", "ไม่สามารถ Export ข้อมูลได้");
    }
}

export async function ExportHistoryStock(data, year, month) {
    if (!Array.isArray(data) || data.length === 0) {
        return getAlert("FAILED", "ไม่มีข้อมูลสินค้าเคลื่อนไหว");
    }

    try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("สินค้าเคลื่อนไหว_" + month + "-" + year);

        // ตั้งค่าคอลัมน์
        worksheet.columns = [
            { header: "#", key: "index", width: 5 },
            { header: "รหัสสินค้า", key: "Item_Code", width: 15 },
            { header: "ชื่อสินค้า", key: "Item_Name", width: 25 },
            { header: "ประเภท", key: "Doc_Type", width: 10 },
            { header: "จำนวน", key: "STC_QTY", width: 10 },
            { header: "จำนวนคงเหลือ", key: "STC_Balance", width: 15 },
            { header: "วันที่ทำรายการ", key: "STC_Date", width: 20 },
            { header: "คลังสินค้า", key: "WH_Name", width: 25 },
            { header: "เลขเอกสาร", key: "Doc_No", width: 20 },
            { header: "เอกสารอ้างอิง", key: "Doc_NoRef", width: 20 },
            { header: "หมายเหตุ", key: "STC_Remark", width: 20 },
        ];

        worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFEF6C00" },
            };
            cell.alignment = { vertical: "middle", horizontal: "center" };
        });

        // เพิ่มข้อมูล
        data.forEach((item, index) => {
            worksheet.addRow({
                index: index + 1,
                Item_Code: item.Item_Code,
                Item_Name: item.Item_Name,
                Doc_Type: item.Doc_Type,
                STC_QTY: formatCurrency(item.STC_QTY),
                STC_Balance: formatCurrency(item.STC_Balance),
                STC_Date: formatDateAndTime(item.STC_Date),
                WH_Name: item.WH_Name,
                Doc_No: item.Doc_No,
                Doc_NoRef: item.Doc_NoRef,
                STC_Remark: item.STC_Remark || '-',
            });
        });

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), "สินค้าเคลื่อนไหว_" + month + "-" + year + ".xlsx");
    } catch (error) {
        console.error("Error exporting stock history:", error);
        getAlert("FAILED", "ไม่สามารถ Export ข้อมูลได้");
    }
}

export async function ExportPaymentStockReport(data) {
    if (!Array.isArray(data) || data.length === 0) {
        return getAlert("FAILED", "ไม่มีข้อมูลลูกค้าค้างจ่าย");
    }

    try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("ลูกค้าค้างจ่าย");

        worksheet.columns = [
            { header: "รหัสลูกค้า", key: "AR_Code", width: 15 },
            { header: "ชื่อลูกค้า", key: "AR_Name", width: 30 },
            { header: "คงเหลือ", key: "Item_Onhand", width: 15 },
        ];

        worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFF0000" } };
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFFFFF00" },
            };
            cell.alignment = { vertical: "middle", horizontal: "center" };
            cell.border = {
                top: { style: "thin", color: { argb: "FF000000" } },
                left: { style: "thin", color: { argb: "FF000000" } },
                bottom: { style: "thin", color: { argb: "FF000000" } },
                right: { style: "thin", color: { argb: "FF000000" } },
            };
        });

        let totalAmount = 0; // ตัวแปรสำหรับคำนวณยอดรวม

        data.forEach((item) => {
            const row = worksheet.addRow({
                AR_Code: item.AR_Code,
                AR_Name: item.AR_Name,
                Item_Onhand: formatCurrency(item.Item_Onhand),
            });
            totalAmount += item.Item_Onhand; // คำนวณยอดรวม

            row.eachCell((cell) => {
                cell.border = {
                    top: { style: "thin", color: { argb: "FF000000" } },
                    left: { style: "thin", color: { argb: "FF000000" } },
                    bottom: { style: "thin", color: { argb: "FF000000" } },
                    right: { style: "thin", color: { argb: "FF000000" } },
                };
            });
        });

        // คำนวณข้อความสำหรับ Footer
        let footerMessage = "";
        if (totalAmount < 0) {
            footerMessage = `ค้างจ่าย ${formatCurrency(totalAmount)} บาท`;
        } else if (totalAmount > 0) {
            footerMessage = `จ่ายเกิน ${formatCurrency(totalAmount)} บาท`;
        } else {
            footerMessage = `ไม่ค้างจ่าย 0.00 บาท`;
        }

        // เพิ่มแถว Footer
        worksheet.addRow([]);

        // Merge columns B and C for the footer and put the message in column C
        worksheet.mergeCells(`B${worksheet.lastRow.number}:C${worksheet.lastRow.number}`);
        const footerCell = worksheet.getCell(`B${worksheet.lastRow.number}`);
        footerCell.value = footerMessage; // Put the footerMessage in the merged cell

        // Apply styling to the footer cell
        footerCell.alignment = { horizontal: "right", vertical: "center" };
        footerCell.font = { color: { argb: "FF0000" }, bold: true };
        footerCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFFF00" },
        };

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), "ลูกค้าค้างจ่าย.xlsx");
    } catch (error) {
        console.error("Error exporting filtered AR list:", error);
        getAlert("FAILED", "ไม่สามารถ Export ข้อมูลได้");
    }
}

export async function ExportPo(data) {
    if (!Array.isArray(data) || data.length === 0) {
        return getAlert("FAILED", "ไม่มีข้อมูลใบสั่งซื้อ");
    }

    try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("ใบสั่งซื้อ");

        // ตั้งค่าหัวตาราง (ตามตัวอย่าง JSON)
        worksheet.columns = [
            { header: "เลขที่เอกสาร", key: "docNo", width: 15 },
            { header: "ประเภท", key: "type", width: 20 },
            { header: "สถานะเอกสาร", key: "status", width: 15 },
            { header: "สถานะรับสินค้า", key: "receiveStatus", width: 20 },
            { header: "สถานะชำระเงิน", key: "paymentStatus", width: 15 },
            { header: "วันที่เอกสาร", key: "docDate", width: 20 },
            { header: "วันที่จัดส่ง", key: "deliveryDate", width: 20 },
            { header: "รหัสเจ้าหนี้", key: "vendorCode", width: 20 },
            { header: "ชื่อเจ้าหนี้", key: "vendorName", width: 30 },
            { header: "ยอดรวม", key: "total", width: 15 },
            { header: "สร้างรายการโดย", key: "createdBy", width: 25 },
            { header: "รายละเอียดเอกสาร", key: "remark1", width: 30 },
            { header: "หมายเหตุธุรการ", key: "remark2", width: 30 },
        ];

        worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFEF6C00" },
            };
            cell.alignment = { vertical: "middle", horizontal: "center" };
        });

        // เพิ่มข้อมูลจาก JSON (mapping ตามตัวอย่าง JSON)
        data.forEach((item) => {
            worksheet.addRow({
                docNo: item.Doc_No,
                type: item.DocType_Name,
                status: item.DocStatus_Name,
                receiveStatus: item.Doc_Status_ReceiveName,
                paymentStatus: item.Doc_Status_PaidName,
                docDate: formatDate(item.Doc_Date),
                deliveryDate: formatDate(item.Doc_DueDate),
                vendorCode: item.AP_Code,
                vendorName: item.AP_Name,
                total: formatCurrency(item.NetTotal),
                createdBy: item.Created_By_Name,
                remark1: item.Doc_Remark1 || "",
                remark2: item.Doc_Remark2 || "",
            });
        });

        // ตั้งค่าเส้นขอบให้ทุกเซลล์
        worksheet.eachRow((row) => {
            row.eachCell((cell) => {
                cell.border = {
                    top: { style: "thin", color: { argb: "FF000000" } },
                    left: { style: "thin", color: { argb: "FF000000" } },
                    bottom: { style: "thin", color: { argb: "FF000000" } },
                    right: { style: "thin", color: { argb: "FF000000" } },
                };
            });
        });

        // บันทึกไฟล์
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), "ใบสั่งซื้อ.xlsx");
    } catch (error) {
        console.error("Error exporting purchase order:", error);
        getAlert("FAILED", "ไม่สามารถ Export ข้อมูลได้");
    }
}

export async function ExportSo(data) {
    if (!Array.isArray(data) || data.length === 0) {
        return getAlert("FAILED", "ไม่มีข้อมูลใบขาย");
    }

    try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("ใบขาย");

        // ตั้งค่าหัวตารางตามคอลัมน์ในรูป
        worksheet.columns = [
            { header: "เลขที่เอกสาร", key: "docNo", width: 15 },
            { header: "เลขที่ใบวางบิล", key: "invoiceNo", width: 15 },
            { header: "เลขที่กำกับภาษี", key: "taxNo", width: 15 },
            { header: "สถานะจ่าย", key: "paymentStatus", width: 15 },
            { header: "ประเภทการจ่าย", key: "paymentType", width: 15 },
            { header: "วันที่เอกสาร", key: "docDate", width: 20 },
            { header: "Due Date", key: "dueDate", width: 20 },
            { header: "รหัสลูกค้า", key: "customerCode", width: 20 },
            { header: "ชื่อผู้รับสินค้า", key: "customerName", width: 30 },
            { header: "ยอดรวม", key: "total", width: 15 },
        ];

        worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFEF6C00" },
            };
            cell.alignment = { vertical: "middle", horizontal: "center" };
        });

        // เพิ่มข้อมูลจาก JSON โดยแมปคีย์ตามที่ระบุ
        data.forEach((item) => {
            worksheet.addRow({
                docNo: item.Doc_No,
                invoiceNo: item.Doc_BL_No || "-",
                taxNo: item.Doc_INV_No || "-",
                paymentStatus: item.DocStatusPaid_Name || "ยกเลิก",
                paymentType: item.DocStatusPaid_Type_Name || "ยกเลิก",
                docDate: formatDate(item.Doc_Date),
                dueDate: formatDate(item.Doc_DueDate),
                customerCode: item.AR_Code,
                customerName: item.AR_Name,
                total: formatCurrency(item.NetTotal),
            });
        });

        // ตั้งค่าเส้นขอบให้ทุกเซลล์
        worksheet.eachRow((row) => {
            row.eachCell((cell) => {
                cell.border = {
                    top: { style: "thin", color: { argb: "FF000000" } },
                    left: { style: "thin", color: { argb: "FF000000" } },
                    bottom: { style: "thin", color: { argb: "FF000000" } },
                    right: { style: "thin", color: { argb: "FF000000" } },
                };
            });
        });

        // บันทึกไฟล์
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), "ใบขาย.xlsx");
    } catch (error) {
        console.error("Error exporting sales order:", error);
        getAlert("FAILED", "ไม่สามารถ Export ข้อมูลได้");
    }
}